import React, { type MouseEventHandler, useEffect } from 'react'
import TagManager from 'react-gtm-module'

import type { SubscriptionsAnalyticsSource } from '../../Subscriptions.types'
import * as S from './UpgradeSubscriptionButton.styled'
import type { UpgradeSubscriptionButtonSize } from './UpgradeSubscriptionButton.types'

export type UpgradeSubscriptionButtonProps = {
  fullWidth?: boolean
  label?: string
  type?: 'button' | 'submit' | 'reset'
  size?: UpgradeSubscriptionButtonSize
  source?: SubscriptionsAnalyticsSource
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const UpgradeSubscriptionButton = ({
  fullWidth = false,
  label = 'Upgrade to Pro',
  type = 'button',
  size = 'small',
  source,
  onClick,
}: UpgradeSubscriptionButtonProps) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: 'upgrade_button_displayed', source },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.Container $fullWidth={fullWidth} size={size} type={type} onClick={onClick}>
      {label}
    </S.Container>
  )
}
